import { connect } from 'react-redux';
import { getLocationParametersDivisionId } from 'redux-core/router/selectors';

const mapStateToProps = (state) => ({
  divisionId: getLocationParametersDivisionId(state),
});

export default connect(mapStateToProps);
